import Vue from 'vue'

export const addComponentInstance = (state, componentInstance) => {
  Vue.set(state.componentInstances, componentInstance.name, componentInstance)
}

export const removeComponentInstance = (state, componentInstanceName) => {
  Vue.delete(state.componentInstances, componentInstanceName)
}
